import { useMemo } from 'react';
import {
  useSelectedCallerID,
  useSelectedCall,
} from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { getMostRecentLoc } from '@rsos/utils/getMostRecentLoc';
import type { AirAmbulanceFormValues } from '../../types';
import { DEFAULT_FORM_VALUES } from '../constants';
import { formatAddressFromObject } from '../utils';
import { formatCoordinates } from '../validation';

interface Location {
  latitude: number;
  longitude: number;
  addressObject?: Record<string, string | undefined>;
  rgAddress?: string;
}

const useInitialFormValues = (): AirAmbulanceFormValues => {
  const selectedCallerID = useSelectedCallerID();
  const selectedCall = useSelectedCall();

  return useMemo(() => {
    // Populate the form with the location from the selected call if available.
    if (!selectedCallerID || !selectedCall) {
      return DEFAULT_FORM_VALUES;
    }

    const latestLocation = getMostRecentLoc(selectedCall) as Location | null;

    if (!latestLocation) {
      return DEFAULT_FORM_VALUES;
    }

    const formattedAddress = latestLocation.addressObject
      ? formatAddressFromObject(latestLocation.addressObject)
      : latestLocation.rgAddress || '';

    return {
      ...DEFAULT_FORM_VALUES,
      pickup_coordinates: formatCoordinates(
        latestLocation.latitude,
        latestLocation.longitude,
      ),
      pickup_location: formattedAddress,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- selectedCall intentionally excluded: including it would reset the address every time Hermes updates a new location
  }, [selectedCallerID]);
};

export default useInitialFormValues;
